import { useCallback, useEffect, useRef } from 'react';

export function useDebounceCallback<T extends (...args: Parameters<T>) => void>(
  callback: T,
  delay: number
): (...args: Parameters<T>) => void {
  const handlerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  const debouncedCallback = useCallback(
    (...args: Parameters<T>) => {
      if (handlerRef.current) {
        clearTimeout(handlerRef.current);
      }
      handlerRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  useEffect(() => {
    return () => {
      if (handlerRef.current) {
        clearTimeout(handlerRef.current);
      }
    };
  }, []);

  return debouncedCallback;
}
